var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMember(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 29,
    viewBox: "0 0 39 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M17.185 28.0489C17.185 28.0489 14.8701 28.0489 14.8701 25.7114C14.8701 23.374 17.185 16.3618 26.4443 16.3618C35.7036 16.3618 38.0185 23.374 38.0185 25.7114C38.0185 28.0489 35.7036 28.0489 35.7036 28.0489H17.185ZM26.4443 14.0244C28.2861 14.0244 30.0525 13.2856 31.3548 11.9706C32.6571 10.6556 33.3888 8.87197 33.3888 7.01221C33.3888 5.15246 32.6571 3.36888 31.3548 2.05383C30.0525 0.738785 28.2861 0 26.4443 0C24.6025 0 22.8361 0.738785 21.5338 2.05383C20.2314 3.36888 19.4998 5.15246 19.4998 7.01221C19.4998 8.87197 20.2314 10.6556 21.5338 11.9706C22.8361 13.2856 24.6025 14.0244 26.4443 14.0244Z",
    fill: "#6AA287"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0556 28.0487C12.7124 27.319 12.5413 26.519 12.5556 25.7113C12.5556 22.5442 14.1297 19.2835 17.0371 17.0162C15.5859 16.5647 14.074 16.3439 12.5556 16.3617C3.29628 16.3617 0.981445 23.3739 0.981445 25.7113C0.981445 28.0487 3.29628 28.0487 3.29628 28.0487H13.0556Z",
    fill: "#6AA287"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3979 14.0244C12.9327 14.0244 14.4046 13.4088 15.4899 12.3129C16.5752 11.217 17.1849 9.73071 17.1849 8.18091C17.1849 6.63112 16.5752 5.1448 15.4899 4.04893C14.4046 2.95306 12.9327 2.3374 11.3979 2.3374C9.86304 2.3374 8.39109 2.95306 7.30582 4.04893C6.22054 5.1448 5.61084 6.63112 5.61084 8.18091C5.61084 9.73071 6.22054 11.217 7.30582 12.3129C8.39109 13.4088 9.86304 14.0244 11.3979 14.0244Z",
    fill: "#6AA287"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMember);
export default __webpack_public_path__ + "static/media/member.d8ef4ff20382c2e155c03b2ff4bf3891.svg";
export { ForwardRef as ReactComponent };